import Skeleton from '../MLSDetails/Skeletons/DetailsDataSkeleton'

const PropertyDetailsSkeleton: React.FC = () => (
  <>
    <div className='inline-flex w-80 snap-center flex-col divide-y divide-gray-200 overflow-hidden rounded-xl bg-white pb-[35px] align-top shadow-md'>
      <div className='px-4 pb-1 pt-2 font-medium'>MLS Details</div>
      <Skeleton />
    </div>
    <div className='inline-flex w-80 snap-center flex-col divide-y divide-gray-200 overflow-hidden rounded-xl bg-white align-top shadow-md'>
      <div className='px-4 pb-1 pt-2 font-medium'>Public Records</div>
      <Skeleton />
    </div>
  </>
)

export default PropertyDetailsSkeleton
